import { API_CONSTS } from "../constants/api.consts";
import { apiClient } from "../services/api";

export async function replayFailedRequests() {
  const queue = JSON.parse(
    localStorage.getItem(API_CONSTS.RETRY_QUEUE) || "[]"
  );

  for (const req of queue) {
    await apiClient
      .request({
        url: req.url,
        method: req.method,
        data: req.data,
      })
      .catch((error) => {
        console.error("Error replaying failed request:", error);
      });
  }

  localStorage.removeItem(API_CONSTS.RETRY_QUEUE);
}
